import { Reveal, SectionHeading } from "./Reveal";
import { SERVICES } from "../../data/content";

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative border-t border-[#c9a24d]/25 bg-[#0a0a0a] py-24 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal>
          <SectionHeading
            center
            overline="What We Do"
            title="Full-service contracting, end to end."
            sub="Custom residential builds and bespoke renovations across Toronto, Etobicoke, Scarborough, North York, Mississauga and Oakville."
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.06}>
              <div
                data-testid={`service-card-${i}`}
                className="group relative overflow-hidden border border-gold/20 transition-all duration-300 hover:-translate-y-1.5 hover:border-gold/50"
              >
                <div className="relative h-[230px] overflow-hidden">
                  <img
                    src={s.image}
                    alt={`${s.title} in Toronto | Blacklion Construction Group`}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.06]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                  <span className="absolute left-4 top-4 border border-gold/35 bg-black/55 px-2.5 py-1 font-mono text-[11px] tracking-wide text-white">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <div className="border-t-2 border-gold bg-[#161b22] px-6 pb-7 pt-6">
                  <h3 className="font-hero text-xl font-semibold text-white">
                    {s.title}
                  </h3>
                  <p className="mb-4 mt-2.5 text-[13px] leading-relaxed text-neutral-400">
                    {s.desc}
                  </p>
                  <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider text-gold">
                    Learn more
                    <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">
                      &rarr;
                    </span>
                  </span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
